import React, { memo } from 'react'
import LazyLoad from 'react-lazyload';
import {GalleryItem} from "./models/GalleryItem";
import GalleryThumb from './GalleryThumb'

interface GalleryThumbsProps {
    galleryItems: GalleryItem[];
    description: string;
    largeThumbFilename:string;
    activeImage: GalleryItem;
    onGalleryClick: (arg:GalleryItem) => void;
}

const GalleryThumbs = (props:GalleryThumbsProps) => {
    return (
        <LazyLoad once className="thumbs">
            {props.galleryItems.map((t) => (
                <GalleryThumb
                    key={t.originalUrl}
                    isActive={props.activeImage == t}
                    thumbnailUrl={t.thumbnailUrl}
                    altText={t.altText}
                    onGalleryClick={() => props.onGalleryClick(t)}
                    originalUrl={t.originalUrl}
                />
            ))}
        </LazyLoad>
    )
}

export const MemoisedGalleryThumbs = memo(GalleryThumbs)